import React from "react";
import {
  Grid,
  TableBody,
  TableRow,
  CardContent,
  Divider,
  Card,
} from "@material-ui/core";
import TableBodyCell from "components/table/TableBodyCell";
import { BootstrapBadge } from "components/ui/BootstrapBadge";
import { readableFormatDate } from "shared/utils";
import { CustomTableWrapper } from "shared/components/CustomTableWrapper";
import { RobotFont } from "components/ui/RobotFont";

export const Cashfree = ({ data }) => {
  return (
    <Card>
      <CardContent className="card-content_head">
        <Grid container alignItems="center">
          <Grid item xs={6}>
            Cashfree Details
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <CustomTableWrapper>
          <Grid item xs={6}>
            <table className="w-full">
              <TableBody>
              <TableRow>
                <TableBodyCell className="common_table_title">Order Id</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["order_id"]}</TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
              <TableRow>
                <TableBodyCell className="common_table_title">Order Status</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["order_status"]}</TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
              <TableRow>
                <TableBodyCell className="common_table_title">Order Amount</TableBodyCell>
                <TableBodyCell className="common_table_content">
                  <RobotFont type="medium">₹ </RobotFont>
                  {data["order_amount"]}
                </TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
              <TableRow>
                <TableBodyCell className="common_table_title">TXN Status</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["txn_status"]}</TableBodyCell>
                </TableRow>
              </TableBody>
              {/* <TableBody>
                <TableBodyCell>Status</TableBodyCell>
                <TableBodyCell><BootstrapBadge backgroundColor="#0ABB87" text={data['status']} /></TableBodyCell>
              </TableBody> */}
              <TableBody>
              <TableRow>
                <TableBodyCell className="common_table_title">Txn Timestamp</TableBodyCell>
                <TableBodyCell className="common_table_content">
                  {readableFormatDate(data["txn_timestamp"])}
                </TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
              <TableRow>
                <TableBodyCell className="common_table_title">Txn Message</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["txn_message"]}</TableBodyCell>
                </TableRow>
              </TableBody>
            </table>
          </Grid>

          <Grid item xs={6}>
            <table className="w-full">
              {/* <TableBody>
                <TableBodyCell>Error Code</TableBodyCell>
                <TableBodyCell>{data['error_code']}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell>Error Description</TableBodyCell>
                <TableBodyCell>{data['error_description']}</TableBodyCell>
              </TableBody> */}

              <TableBody>
              <TableRow>
                <TableBodyCell className="common_table_title">Txn Message</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["txn_message"]}</TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
              <TableRow>
                <TableBodyCell className="common_table_title">Payment Mode</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["payment_mode"]}</TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
              <TableRow>
                <TableBodyCell className="common_table_title">Created Date</TableBodyCell>
                <TableBodyCell className="common_table_content">
                  {readableFormatDate(data["created_at"])}
                </TableBodyCell>
                </TableRow>
              </TableBody>
              <TableBody>
              <TableRow>
                <TableBodyCell className="common_table_title">Updated At</TableBodyCell>
                <TableBodyCell className="common_table_content">
                  {readableFormatDate(data["updated_at"])}
                </TableBodyCell>
                </TableRow>
              </TableBody>
            </table>
          </Grid>
        </CustomTableWrapper>
      </CardContent>
    </Card>
  );
};
